
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/ZAUNTRIP-Logo1.png';
import { logout } from '../services/api';
import { LayoutDashboard, FileText, Package, Users, LogOut, Menu, X } from 'lucide-react';

const Sidebar = ({ role }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const employeeName = localStorage.getItem('employee_name') || '';
  const employeeCode = localStorage.getItem('employee_code') || '';

  const handleLogout = () => {
    logout()
      .then(() => {
        localStorage.clear();
        navigate('/login');
      })
      .catch(err => console.error('Error logging out:', err));
  };

  const NavLinks = () => (
    <>
      <Link to="/dashboard" onClick={() => setIsOpen(false)} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded-lg">
        <LayoutDashboard className="w-5 h-5 mr-2 flex-shrink-0" /> Dashboard
      </Link>
      <Link to="/dashboard/fill-package" onClick={() => setIsOpen(false)} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded-lg">
        <FileText className="w-5 h-5 mr-2 flex-shrink-0" /> Fill Package Form
      </Link>
      <Link to="/dashboard/view-packages" onClick={() => setIsOpen(false)} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded-lg">
        <Package className="w-5 h-5 mr-2 flex-shrink-0" /> View Packages
      </Link>
      {role === 'super_admin' && (
        <Link to="/dashboard/users" onClick={() => setIsOpen(false)} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded-lg">
          <Users className="w-5 h-5 mr-2 flex-shrink-0" /> Manage Users
        </Link>
      )}
    </>
  );

  const UserInfo = () => (
    <div className="mb-6 ml-1">
      <p className="text-sm text-gray-600">Welcome back,</p>
      <p className="font-bold text-gray-900 text-lg">{employeeName || 'Employee'}</p>
      {employeeCode && (
        <span className="inline-block mt-1 text-xs px-2 py-1 bg-indigo-100 text-indigo-700 rounded-full">
          ID: {employeeCode}
        </span>
      )}
      <div className="inline-block mt-1 ml-1 text-xs px-2 py-1 bg-indigo-50 text-indigo-700 rounded-full">
        Role: {role}
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile/Tablet Top Bar */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white shadow-md flex items-center justify-between px-4 py-2">
        <img src={logo} alt="Logo" className="h-10 object-contain" />
        <button onClick={() => setIsOpen(!isOpen)} className="p-2 rounded-md text-gray-700 hover:bg-gray-100">
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Drawer Overlay */}
      {isOpen && (
        <div className="lg:hidden fixed inset-0 bg-black bg-opacity-40 z-40" onClick={() => setIsOpen(false)} />
      )}

      {/* Mobile Drawer */}
      <div className={`lg:hidden fixed top-0 left-0 h-full w-72 bg-gradient-to-b from-gray-50 to-gray-200 text-gray-800 p-6 shadow-2xl z-50 flex flex-col transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="mb-6 flex items-center justify-between">
          <img src={logo} alt="Logo" className="h-14 object-contain" />
          <button onClick={() => setIsOpen(false)} className="p-1 rounded text-gray-600 hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>
        <UserInfo />
        <nav className="space-y-2 flex-1"><NavLinks /></nav>
        <div className="pt-4 mt-auto">
          <button className="w-full flex items-center justify-center bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 transition-colors" onClick={handleLogout}>
            <LogOut className="w-5 h-5 mr-2" /> Sign Out
          </button>
        </div>
      </div>

      {/* Desktop Sidebar */}
      <div className="hidden lg:flex w-64 bg-white bg-gradient-to-b from-gray-50 to-gray-200 text-gray-800 p-6 shadow-2xl fixed h-full flex-col z-50">
        <div className="mb-8 flex items-center">
          <img src={logo} alt="TravelCost Pro Logo" className="object-contain" style={{ height: '80px', width: '200px' }} />
        </div>
        <UserInfo />
        <nav className="space-y-2 flex-1"><NavLinks /></nav>
        <div className="pt-6 mt-auto">
          <button className="w-full flex items-center justify-center bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 transition-colors" onClick={handleLogout}>
            <LogOut className="w-5 h-5 mr-2" /> Sign Out
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;